module.exports = __webpack_public_path__ + "img/zanorari26.23e1e9cc.jpg";